export interface AuthSetup {
    useLogin: boolean;
    requireAccessControl: boolean;
    loginUrl: string;
    isAuthenticated: boolean;
}

async function fetchAuthSetup(): Promise<AuthSetup> {
    const res = await fetch("/auth_setup", { credentials: "include" });
    const json = await res.json();
    return json;
}

const { useLogin, requireAccessControl, loginUrl, isAuthenticated } = await fetchAuthSetup();

export { useLogin, requireAccessControl, loginUrl, isAuthenticated };

